import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ status, nextStatus }) =>
    present(
      repository
        .updateProjectStatus(status, nextStatus)
        .then((savedStatus) => ({ status: savedStatus }))
        .catch((error) => Promise.reject({ error, status, nextStatus })),
    );
}

export type { Interactor };

export { createInteractor };
